import { Box, makeStyles, Switch } from '@material-ui/core';
import React from 'react';
import { updateBanner } from '../../../services/masterDataService';
import ScreenWrapper from '../../commons/ScreenWrapper';
import Text from '../../commons/Text';
import BannerForm from '../../layouts/Admin/Banner/BannerForm';

const useStyles = makeStyles(theme => ({
    switch: {
        '& .MuiSwitch-track': {
            backgroundColor: theme.palette.ascents.white
        }
    }
}))

const BannerFormScreen = ({
    title,
    match,
    readOnly = false
}) => {
    const classes = useStyles()
    const { id } = match && match.params ? match.params : {};
    const [bannerIsActive, setBannerIsActive] = React.useState(false);

    const handleChange = (event) => {
        const { checked } = event.target
        setBannerIsActive(checked)

        updateBanner({
            is_active: checked ? 1 : 0
        }, id).then((response) => {
            console.log(response);
        })
    };

    return (
        <ScreenWrapper
            pageTitle={title}
            hasForm
            ActionComponent={
                () => id ? (
                    <Box display='flex' alignItems='center' justifyContent='flex-end'>
                        <Text fontWeight={600} style={{ marginRight: 16 }}>Visibility:</Text>
                        <Text opacity={!bannerIsActive ? 1 : 0.5}>Draft</Text>
                        <Switch
                            className={classes.switch}
                            checked={bannerIsActive}
                            onChange={handleChange}
                            name="bannerIsActive"
                            inputProps={{ 'aria-label': 'toggle banner active status' }}
                        />
                        <Text opacity={bannerIsActive ? 1 : 0.5}>Public</Text>
                    </Box>
                ) : null
            }
        >
            <BannerForm match={match} readOnly={readOnly} setBannerIsActive={setBannerIsActive} />
        </ScreenWrapper>
    )
}

export default BannerFormScreen